<p-menubar [model]="AdminItems" #adminMenuBar *ngIf="user.usr_type_str === EUserType.USER" [autoDisplay]="false">
    <ng-template pTemplate="start">
        <img routerLink="/dashboard" src="../../assets/pb_logo.png" width="35" class="cursor-pointer" alt="PB logo">
    </ng-template>
    <ng-template pTemplate="end">
        <p-menu #adminMenuBarUserMenu [model]="userItems" [popup]="true"/>
        <p-button (click)="adminMenuBarUserMenu.toggle($event)" icon="pi pi-user"/>
    </ng-template>
</p-menubar>

<p-menubar [model]="AdminItems" #adminMenuBar *ngIf="user.usr_type_str === EUserType.OPERATOR" [autoDisplay]="false">
    <ng-template pTemplate="start">
        <img routerLink="/dashboard" src="../../assets/pb_logo.png" width="35" class="cursor-pointer" alt="PB logo">
    </ng-template>
    <ng-template pTemplate="end">
        <p-menu #adminMenuBarUserMenu [model]="userItems" [popup]="true"/>
        <p-button (click)="adminMenuBarUserMenu.toggle($event)" icon="pi pi-user"/>
    </ng-template>
</p-menubar>

<p-menubar [model]="AdminItems" #adminMenuBar *ngIf="user.usr_type_str === EUserType.MANAGER" [autoDisplay]="false">
    <ng-template pTemplate="start">
        <img routerLink="/dashboard" src="../../assets/pb_logo.png" width="35" class="cursor-pointer" alt="PB logo">
    </ng-template>
    <ng-template pTemplate="end">
        <p-menu #adminMenuBarUserMenu [model]="userItems" [popup]="true"/>
        <p-button (click)="adminMenuBarUserMenu.toggle($event)" icon="pi pi-user"/>
    </ng-template>
</p-menubar>

<p-menubar [model]="AdminItems" #adminMenuBar *ngIf="user.usr_type_str === EUserType.ADMIN" [autoDisplay]="false">
    <ng-template pTemplate="start">
        <img routerLink="/admin-dashboard" src="../../assets/pb_logo.png" width="35" class="cursor-pointer" alt="PB logo">
    </ng-template>
    <ng-template pTemplate="end">
        <p-menu #adminMenuBarUserMenu [model]="userItems" [popup]="true"/>
        <p-button (click)="adminMenuBarUserMenu.toggle($event)" icon="pi pi-user"/>
    </ng-template>
</p-menubar>

<p-menubar [model]="RootItems" #rootMenuBar *ngIf="user.usr_type_str === EUserType.ROOT" [autoDisplay]="false">
    <ng-template pTemplate="start">
        <img routerLink="/root-dashboard" src="../../assets/pb_logo.png" width="35" class="cursor-pointer" alt="PB logo">
    </ng-template>
    <ng-template pTemplate="end">
        <p-menu #rootMenuBarUserMenu [model]="userItems" [popup]="true"/>
        <p-button (click)="rootMenuBarUserMenu.toggle($event)" icon="pi pi-user"/>
    </ng-template>
</p-menubar>
<app-edit-user-profile #editProfileFormModal></app-edit-user-profile>
